﻿var jquery = require('jquery');
var HabEvents = require('../../Global/habitaclia-events');

(function () {
    'use strict';


    var AccountUser = function (accountUserDTO) {
        this.__accountUserDTO = accountUserDTO;
        this.__$showModalLogin = jquery('#js-show-login');
        this.__openlogin = new window.Event('openCloseLoginModal');
        this.__openLegalGoogle = new window.Event('showLegalGoogleModal');
        this.__openLegalFacebook = new window.Event('showLegalFacebookModal');
        window.succesFulLoginEvent = new window.Event('widgetLoginSuccess');
    };

    var __registerEvents = function () {
        var self = this;

        this.__$showModalLogin.click(function (e) {
            e.preventDefault();
            __showModalLogin.call(self);
        });

        window.addEventListener('widgetLoginSuccess', () => {
            jquery.publish(HabEvents.EventsEnum.LoginAjaxOk);
        });

        jquery.subscribe(HabEvents.EventsEnum.ShowModalLegalLogin, (e,type) => {
            switch (type) {
                case 'google':
                    window.dispatchEvent(self.__openLegalGoogle);
                    break;
                case 'facebook':
                    window.dispatchEvent(self.__openLegalFacebook);
                    break;
                default:
                    __showModalLogin.call(self);
                    break;
            }
        });
    };

    var __showModalLogin = function () {
        window.dispatchEvent(this.__openlogin);
    };

    AccountUser.prototype = {
        constructor: AccountUser,
        ShowModalLogin: __showModalLogin,
        RegisterEvents: __registerEvents
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = new AccountUser(AccountUserDTO);
    }
    else {
        window.AccountUser = AccountUser;
    }

})();